module.exports = __webpack_public_path__ + "img/ket-test-head.b9e2c1b6.png";